import React from "react";
import { useParams } from "react-router-dom";
import TokenExchangePanel from "./TokenExchangePanel";

const TokenExchangePanelWrapper = (props) => {
  const { appid, regid } = useParams();

  return (
    <TokenExchangePanel
      {...props}
      appid={appid}
      regid={regid}
      breadcrumbs={[
        ["/", "Applications"],
        [`/manage/${appid}`, "My Application"],
        [`/token-exchange/${appid}/${regid}`, "Token exchange permissions"],
      ]}
    />
  );
};

export default TokenExchangePanelWrapper;
